module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyt"
  }, [_vm._v("PUBLISHER: Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("CREATIVE DIRECTOR: Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ACQUISITIONS EDITOR: Roxane Cerda")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("MANAGING EDITOR: Liz Aneloski")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("EDITOR: Christine Doyle")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("TECHNICAL EDITOR: Julie Waldman")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("COVER/BOOK DESIGNER: April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("PRODUCTION COORDINATOR: Tim Manibusan")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ILLUSTRATORS: Tim Manibusan and April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("PRODUCTION EDITOR: Jennifer Warren")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("PHOTO ASSISTANT: Mai Yong Vang")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Styling by Anna Marisa Martinez")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Style photography by Lucy Glover and flat-shot photography by Mai Yong Vang of C&T Publishing, Inc., unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by Stash Books, an imprint of C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c9298c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_copyright.vue
// module id = 60
// module chunks = 0